module.exports = __webpack_public_path__ + "static/media/icon-bigscreen.21b6a465.svg";